import SqFetch from 'application/fetch';

export default class EligibilityClient {
  constructor(orderNumber) {
    this.orderNumber = orderNumber;
  }

  _urlContext() {
    return `?order_number=${this.orderNumber}`;
  }

  _handleResponse(response) {
    if (!response.ok) {
      if (response.status === 400) {
        return Promise.reject(response.json());
      }

      throw new Error(
        `Something went wrong making a EligibilityClient request - url: ${response.url} status: ${response.status}`,
      );
    }
    return response.json();
  }

  saasEligibility() {
    return SqFetch.get(
      `/shop/api/v1/eligibility/saas${this._urlContext()}`,
    ).then(this._handleResponse);
  }
}
